var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1309_48",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1309_48",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC4ElEQVR4nO3dvWsUQQCG8bkgUbCzsBGElJITbEyTwkoQJWAhNloIgjaCjZDGQuw9/Ij6T/iFjRZqp4KNRbQR7ARFK5OgIomPLBnBC7d7O3u787H7/srATW7mye7e3uV2jRERERERERERESkJ2A/cAN4Ba7Tfmp3rdaAf7A8F2A7cATborg3gNjAdYvFfhJ59RJ57jQDcDT3jCC353Od3ebeTZx2Y9REgO+DKaAMfAd7n/HKBZR8BVrXSuVZ8BJACChCYAgSmAIEpQGApBHgJXAKOAwvARfuzVog5wE/gZMG4Z+zZZNJiDnC2xNiXSVysAT4BUyXG3gn8IGGxBnjgMP4bEhZrgHsO478mYbEG+ODwQc8KCYs1QOZoibEvkLiYA3wFDhSMu2BfqiYt5gCZX/bjzCPAviwIcBp4DPyhBWIP0HpGAcJSgMAUIDAFCCzWAJ9rHP9EyXFu/feY38BD4DxwENhtT/p2ADPAKeAJNZhocWtaoNgC3Af2lnzMMeALEzBNSyzA1Qrz6wPfKs5TAf4BDpuK7JagAJNsAZMCHlGBjyeWxC5oUsChKhP18cS6EqAHfHSdqI8nllQAYJvdpy/ad1ynmvwehGlaSgGAPcDbLY9/WvbbLMA514mappHOy9Ae8CpnjCslx5hznahpGukEmC8YIzvZ6pUYIztLdmKaRjoBFseMM1NijF2uEzVNI50AgzHjzJU8gDsxTSPNN+NGmW9ivqZpVKMAdVGAYrUttAJsGrPeCpBHx4BhOgbUxXWTVICaKUCxutdbARwpgKWD8DAdhOviukkqQM0UoFjd660AjhTA0kG4o0zTQk8wdgoQmAIEpgCBKUBgChCYAnQggC7cmu+7jwC6dHHgSxdnd46Q0a75CNBvw8X1kr18vY2Q3bZDht30svg2wLS9bYdsehbiPjJZhKWO747Ws79874u/JcSs/Vfw5Y68RF21cx142+eLiIiIiIiIiIhpg79WeDneJVuYZwAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.feb625e96ac9fb108b8c3d3febb75d06.svg";
export { ForwardRef as ReactComponent };